"use client";

import { useState, useEffect } from "react";
import { useParams } from "next/navigation";
import { useTranslations } from "next-intl";
import TFCarousel from "@/Web/Components/TFCarousel/TFCarousel";
import TFLayoutHomeSection from "@/Web/Components/TFLayoutHomeSection/TFLayoutHomeSection";
import apiCall from "@/libs/api";

export default function SectionTestimonials() {
  const t = useTranslations("web.pages.home.sections.testimonials");
  const params = useParams<{ locale: string }>();
  const locale = params?.locale || "en";
  const [testimonials, setTestimonials] = useState<APIDataHubTestimonial[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadTestimonials = async () => {
      try {
        setIsLoading(true);
        const response = await apiCall("hub/testimonials/list", {
          locale: locale as UILocale,
        });
        setTestimonials(response.testimonials);
      } catch (error) {
        console.error("Failed to load testimonials:", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadTestimonials();
  }, [locale]);

  if (isLoading || testimonials.length === 0) {
    return null;
  }

  return (
    <TFLayoutHomeSection
      title={t("title")}
      // description="Узнайте, как Tiferet трансформирует способы изучения священных текстов и взаимодействия с ними"
    >
      <TFCarousel
        items={testimonials}
        renderItem={(testimonial) => (
          <div className="bg-black/5 rounded-xl p-8 space-y-6 h-full">
            <div>
              <div className="font-semibold text-lg text-black mb-2">
                {testimonial.title}
              </div>
              <div className="text-sm text-black/60">
                {testimonial.author}
              </div>
            </div>

            <p className="text-black leading-relaxed text-xl font-light">
              "{testimonial.content}"
            </p>
          </div>
        )}
        autoPlayInterval={6000}
        activeDotClassName="bg-black/30 w-8"
        inactiveDotClassName="bg-black/10 hover:bg-black/20"
      />
    </TFLayoutHomeSection>
  );
}
